<div class="relative">
  <!-- Zone de drop AVANT cet item -->
  <div
    class="absolute -top-3 left-0 right-0 h-6 z-10"
    (dragover)="onDropZoneDragOver($event, 'before')"
    (dragleave)="onDropZoneDragLeave($event)"
    (drop)="onDropZoneDrop($event, 'before')"
  >
    @if (showDropIndicator === 'before') {
      <div
        class="h-1 rounded-full shadow-lg animate-pulse mx-4"
        [class.bg-bleu-1]="color === 'bleu'"
        [class.bg-rose-1]="color === 'rose'"
      >
        <div
          class="absolute left-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full"
          [class.bg-bleu-1]="color === 'bleu'"
          [class.bg-rose-1]="color === 'rose'"
        ></div>
        <div
          class="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full"
          [class.bg-bleu-1]="color === 'bleu'"
          [class.bg-rose-1]="color === 'rose'"
        ></div>
      </div>
    }
  </div>

  <!-- L'item lui-même - SANS événements de drop -->
  <div
    class="cursor-move flex items-center py-2 border-gris-3 transition-all duration-200 relative"
    [class.opacity-30]="isDragging"
    [class.scale-95]="isDragging"
    draggable="true"
    (dragstart)="onDragStart($event)"
    (dragend)="onDragEnd($event)"
  >
    <!-- Ligne verticale de la timeline qui traverse tout l'item -->
    <div
      class="absolute left-3 w-0.5 -translate-x-1/2"
      [ngClass]="{
        'top-1/2': isFirst,
        'top-0': !isFirst,
        'bottom-1/2': isLast,
        'bottom-0': !isLast,
        'bg-bleu-1': color === 'bleu',
        'bg-rose-1': color === 'rose',
      }"
    ></div>

    <div class="relative mr-4">
      <span
        [class.bg-bleu-1]="color === 'bleu'"
        [class.bg-rose-1]="color === 'rose'"
        class="relative w-6 h-6 rounded-full flex items-center justify-center text-sm font-semibold pb-0.5 text-white"
      >
        {{ this.position + 1 }}
      </span>
    </div>

    <div
      class="flex-1 bg-white p-3 flex items-center gap-2 rounded border border-gris-3 relative shadow"
    >
      <div
        class="w-10 h-10 bg-vert-3 rounded-full flex items-center justify-center overflow-hidden"
      >
        <!-- image -->
        <img
          alt="Foyer"
          src="/assets/images/icones/foyer.png"
          class="w-full h-full p-2"
        />
      </div>
      <div class="flex-1 flex flex-col">
        <p class="font-semibold fg-noir-2-contour">{{ this.household.name }}</p>
        <p class="text-xs text-gray-400">
          {{ this.household.enterprise.custom_label?.trim() || this.household.enterprise.name }}
        </p>
      </div>

      <div class="flex items-center ml-auto">
        <button
          class="transition-all hover:bg-gris-3 flex items-center justify-center w-8 h-8 border border-gris-3 rounded"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="size-6 text-gray-400 hover:text-gray-600 cursor-pointer transition-all position-open-button"
            (click)="openPositionEditor()"
          >
            <path
              fill-rule="evenodd"
              d="M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <!-- Éditeur de position inline en absolute -->
      @if (showPositionEditor) {
        <div
          class="position-editor-container absolute top-full right-0 w-fit mt-1 z-20 flex items-center gap-2 bg-white p-2 rounded border border-gray-200 shadow-lg"
        >
          <span class="text-sm text-gray-600 whitespace-nowrap">Position:</span>
          <input
            type="number"
            class="position-editor-input flex-1 min-w-0 px-2 py-1 text-sm !border-2 border-gray-300 rounded-md focus:outline-none focus:!border-[#8ABD27]"
            [formControl]="_inputPosition"
            [min]="1"
            (keydown.enter)="
              _inputPosition.invalid ? null : validatePositionChange()
            "
            (keydown.escape)="cancelPositionEdit()"
            (click)="$event.stopPropagation()"
          />
          <button
            class="cursor-pointer disabled:cursor-not-allowed p-2 rounded bg-vert-3 border-2 border-vert-1 hover:bg-vert-1 hover:text-white transition-colors group disabled:!bg-gray-200 disabled:!border-gray-300 fg-vert-1 disabled:!text-gray-400 hover:!text-white"
            [disabled]="_inputPosition.invalid"
            (click)="
              $event.stopPropagation();
              _inputPosition.invalid ? null : validatePositionChange()
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="3"
              stroke="currentColor"
              class="size-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m4.5 12.75 6 6 9-13.5"
              />
            </svg>
          </button>
        </div>
      }
    </div>
  </div>

  <!-- Zone de drop APRÈS cet item -->
  <div
    class="absolute -bottom-3 left-0 right-0 h-6 z-10"
    (dragover)="onDropZoneDragOver($event, 'after')"
    (dragleave)="onDropZoneDragLeave($event)"
    (drop)="onDropZoneDrop($event, 'after')"
  >
    @if (showDropIndicator === 'after') {
      <div
        [class.bg-bleu-1]="color === 'bleu'"
        [class.bg-rose-1]="color === 'rose'"
        class="h-1 rounded-full shadow-lg animate-pulse mx-4"
      >
        <div
          class="absolute left-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full"
          [class.bg-bleu-1]="color === 'bleu'"
          [class.bg-rose-1]="color === 'rose'"
        ></div>
        <div
          class="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full"
          [class.bg-bleu-1]="color === 'bleu'"
          [class.bg-rose-1]="color === 'rose'"
        ></div>
      </div>
    }
  </div>
</div>
